export const SERVICE_CODE = 'CONTRACT_SERVICE';
